import { render } from "./BlogCategoriesBeauty.vue?vue&type=template&id=95185912&scoped=true"
import script from "./BlogCategoriesBeauty.vue?vue&type=script&lang=js"
export * from "./BlogCategoriesBeauty.vue?vue&type=script&lang=js"

import "./BlogCategoriesBeauty.vue?vue&type=style&index=0&id=95185912&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-95185912"

export default script